import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/image/header/mindtherapiyLogo.svg";
import "./UserPage.css"; // CSS dosyanı ekle

function UserPage({ customImage }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const adminPages = ["/adminhome", "/admintherapistinfo", "/admintherapistdetails", "/adminpayment"];

  const isSettingsButtonHidden = adminPages.includes(location.pathname.toLowerCase());

  const isAdminPageTitleVisible = adminPages.includes(location.pathname.toLowerCase());

  // Kullanıcı tipini URL'den belirle
  const isTherapistPage = location.pathname.toLowerCase().includes("therapist");

  // Profil resmine tıklandığında settings sayfasına yönlendir
  const handleProfileClick = () => {
    if (isTherapistPage) {
      navigate("/therapistSettings");
    } else {
      navigate("/userSettings");
    }
  };

  return (
    <div className={isMobile ? "mobile-container" : "desktop-container"}>
      <div className="user-page notranslate" translate="no">
        <img
          className="logo"
          src={Logo}
          alt="Logo"
          onClick={() => navigate("/")}
        />
        <div className="settings-container">
          {location.pathname === "/userHomePage" && (
            <div>
              
            </div>
          )}

          {/* Admin sayfalarında settings-button'ı göstermiyoruz */}
          {!isSettingsButtonHidden ? (
              <div className="profile-icon" onClick={handleProfileClick}>
                {customImage ? (
                  <img
                    src={customImage}
                    alt="Profile"
                    className="profile-image"
                  />
                ) : null}
              </div>
          ) : null}
        </div>

       
        {isAdminPageTitleVisible && ( 
          <div className="admin-title-container">
            <h1 className="admin-title">Admin Panel</h1>
          </div>
        )}

      </div>
    </div>
  );
}

export default UserPage;